// Product Interfaces
export enum ProductStatus {
    Active = 'Active',
    Inactive = 'Inactive',
    Archived = 'Archived',
}

export const ProductStepId = {
    AddProduct: 'add_product',
    ProductDetails: 'product_details',
    FindSuppliers: 'find_suppliers',
    ConfirmMessage: 'confirm_message',
    ContactWithSuppliers: 'contact_with_suppliers',
    ReceiveOffers: 'receive_offers',
    ProceedThroughDealStages: 'proceed_through_deal_stages',
    SuccessfulDeal: 'successful_deal',
} as const;